import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

type DashboardScaffoldProps = {
  title: string
  description: string
  stats: Array<{ label: string; value: string; highlight?: boolean; to?: string }>
  children?: ReactNode
}

export function DashboardScaffold({
  title,
  description,
  stats,
  children,
}: DashboardScaffoldProps) {
  return (
    <>
      <nav className="mb-2 text-xs text-ink-400">Home / Dashboard</nav>
      <div className="mb-5">
        <h1 className="font-display text-3xl font-bold">{title}</h1>
        <p className="text-ink-600">{description}</p>
      </div>

      <div className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
        {stats.map((stat) => {
          const className = stat.highlight
            ? 'rounded-lg border-[1.5px] border-green-600 bg-green-100 p-4 shadow-card'
            : 'rounded-lg border border-parch-100 bg-white p-4 shadow-card'
          const body = (
            <>
              <div
                className={
                  stat.highlight
                    ? 'text-xs font-semibold text-green-700'
                    : 'text-xs text-ink-400'
                }
              >
                {stat.label}
              </div>
              <div
                className={`mt-1 font-display text-2xl font-bold ${stat.highlight ? 'text-green-800' : ''}`}
              >
                {stat.value}
              </div>
            </>
          )

          if (stat.to) {
            return (
              <Link key={stat.label} to={stat.to} className={`${className} transition hover:opacity-90`}>
                {body}
              </Link>
            )
          }

          return (
            <div key={stat.label} className={className}>
              {body}
            </div>
          )
        })}
      </div>

      {children}
    </>
  )
}
